import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import 'bootstrap/dist/css/bootstrap.min.css';

ChartJS.register(
   CategoryScale,
   LinearScale,
   PointElement,
   LineElement,
   Title,
   Tooltip,
   Legend
);

export default function RateChart({ title, data }) {

   return <Line options={{
      responsive: true,
      plugins: {
         legend: {
            position: 'top'
         },
         title: {
            display: true,
            text: title
         },
      },
   }} data={data} />;
}
